import EnquiryContextTag from './EnquiryContextTag.component';

export default EnquiryContextTag;
